"use client";

import { Tabs as TabsPrimitive } from "@base-ui/react/tabs";
import * as React from "react";

import { cn } from "@/utils/lib";
import { resolveClassName } from "@/utils/resolve-class-name";

const Tabs = TabsPrimitive.Root;

const TabsList = ({
  ref,
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) => (
  <TabsPrimitive.List
    ref={ref}
    className={(state) =>
      cn(
        `
          unforce-radius inline-flex items-center justify-center
          gap-1 border-y border-border text-muted-foreground
        `,
        resolveClassName(className, state),
      )
    }
    {...props}
  />
);
TabsList.displayName = "TabsList";

const TabsTrigger = ({
  ref,
  className,
  nativeButton = false,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Tab>) => (
  <TabsPrimitive.Tab
    ref={ref}
    nativeButton={nativeButton}
    className={(state) =>
      cn(
        `
          inline-flex
          items-center
          justify-center
          px-3
          py-1.5
          text-sm font-medium whitespace-nowrap text-muted ring-offset-background transition-all
          hover:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring
          focus-visible:ring-offset-2 focus-visible:outline-hidden
          disabled:pointer-events-none
          disabled:opacity-50 data-active:bg-transparent
          data-active:text-muted-foreground
        `,
        resolveClassName(className, state),
      )
    }
    {...props}
  />
);
TabsTrigger.displayName = "TabsTrigger";

const TabsContent = ({
  ref,
  className,
  forceMount,
  keepMounted,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Panel> & {
  forceMount?: boolean;
  keepMounted?: boolean;
}) => (
  <TabsPrimitive.Panel
    ref={ref}
    keepMounted={keepMounted ?? forceMount}
    className={(state) =>
      cn(
        `
          ring-offset-background
          focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
          focus-visible:outline-hidden
        `,
        resolveClassName(className, state),
      )
    }
    {...props}
  />
);
TabsContent.displayName = "TabsContent";

export { Tabs, TabsContent, TabsList, TabsTrigger };
